import * as React from 'react';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import actions from 'src/actions';
import * as _ from 'lodash';
import SearchResult from 'src/models/OwnerSearchResult';
import { IRootState } from 'src/reducers';
import selectors from 'src/selectors';
import LeasingOwnerSearch from './LeasingOwnerSearch';
import DialogList from 'src/dialogs';
// import LeaseGenerationForm from 'src/models/leasing/LeaseGenerationForm';
import AgreementsList from './AgreementsList';
import Filter from 'src/components/common/Filter';
import { ODataOptions, ODataOrderByDirection } from 'src/util/ODataBuilder';
// import PagedResultSet from 'src/models/common/PagedResultSet';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import VoidAgreementDialog from './VoidAgreementDialog';
import Lease from 'src/models/leasehold/Lease';
import Project from 'src/models/Project';
import LoadingSpinner from 'src/components/common/LoadingSpinner';
import PagedResultSet from 'src/models/common/PagedResultSet';
import ContractGenerationListDto from 'src/models/leasing/ContractGenerationListDto';
import * as Constants from 'src/components/common/Constants';

export interface ILeasingDispatchProps {
    navigate: (path: string, search?: string) => void;
    searchOwners: (clientNumber: number, projectId: number, searchText: string, ownerType: string) => void;
    showDialog: (dialogname: string) => void;
    getLeaseGenerationCollection: (projectId: number, ownerLookUpId: number) => void;
    getGeneratedContracts: (clientNumber: number, projectNumber: number, options: ODataOptions) => void;
    getProjectData: (clientNumber: number, projectNumber: number) => void;
    incrementPage: (clientNumber: number, projectNumber: number) => void;
    resetPage: () => void;
    getOwnerData: (clientId: number, projectId: number, ownerId: number) => void;
    setAgreementStatus: (
        clientNumber: number,
        projectNumber: number,
        ownerId: number,
        leaseFormId: number,
        leaseType: number,
        status: number,
        explanation: string
    ) => void;
    hideDialog: () => void;
}

export type ILeasingStateProps = {
    searchResults: Array<SearchResult>;
    leaseGenerationCollection: Array<Lease>;
    surfaceAgreements: PagedResultSet<ContractGenerationListDto>;
    ownerData: LeaseGenerationOwnerData;
    projectData: Project;
    pathName: string;
};

type LeasingState = {
    agreementToBeVoided: ContractGenerationListDto;
    leaseType: number;
    searchString: string;
};

type ILeasingProps = RouteComponentProps<{ clientNumber?: string; projectNumber?: string }> & ILeasingDispatchProps & ILeasingStateProps;

class Leasing extends React.Component<ILeasingProps, LeasingState> {
    constructor(props: ILeasingProps) {
        super(props);

        this.state = {
            agreementToBeVoided: undefined,
            leaseType: undefined,
            searchString: undefined
        };
    }

    private clientNumber: number;
    private projectNumber: number;
    private PageNumber: number;
    private contracts: PagedResultSet<ContractGenerationListDto>;

    onGetLeaseGenerationCollection = (ownerLookUpId: number) => {
        this.props.getLeaseGenerationCollection(this.projectNumber, ownerLookUpId);
    };

    componentDidMount() {
        this.clientNumber = parseInt(this.props.match.params.clientNumber, 10);
        this.projectNumber = parseInt(this.props.match.params.projectNumber, 10);
        this.PageNumber = 1;
        this.props.getProjectData(this.clientNumber, this.projectNumber);
    }

    componentWillUnmount(): void {
        this.props.resetPage();
        this.props.hideDialog();
    }

    searchUpdate = _.debounce((searchText: string, ownerType: string) => {
        this.setState({ searchString: searchText });
        this.props.searchOwners(this.clientNumber, this.projectNumber, searchText, ownerType);
    }, 300);

    handleFilterChanged = (options: ODataOptions) => {
        const stringOptions = options.toString();
        if (!(stringOptions.search('orderby') > 0)) {
            options.addOrderBy('leaseNumber', ODataOrderByDirection.Descending);
        }
        this.props.resetPage();
        this.props.getGeneratedContracts(this.clientNumber, this.projectNumber, options);
    };

    getLeaseTypeId = (leaseType: string) => {
        return Object.values(Constants.leaseTypes).findIndex((element) => element === leaseType) + 1;
    }

    onIncrementPage = () => {
        if (this.PageNumber * this.contracts.pageSize < this.contracts.totalRecords) {
            this.props.incrementPage(this.clientNumber, this.projectNumber);
            this.PageNumber++;
        }
    };

    onGetOwnerData = (id: number) => {
        this.props.getOwnerData(this.clientNumber, this.projectNumber, id);
    };
    onVoidAgreement = (reason: string) => {
        // tslint:disable-next-line: max-line-length
        this.props.setAgreementStatus(
            this.clientNumber,
            this.projectNumber,
            this.state.agreementToBeVoided.ownerLookUpId || 0,
            this.state.agreementToBeVoided.agreementId,
            this.getLeaseTypeId(this.state.agreementToBeVoided.leaseType),
            Constants.LeaseStatus.VOID,
            reason
        );
    };
    onShowVoidAgreement = (agreement: ContractGenerationListDto) => {
        this.setState({ agreementToBeVoided: agreement });
        this.props.showDialog(DialogList.VOID_AGREEMENT);
    };

    render() {
        this.contracts = this.props?.surfaceAgreements;

        return (
            <>
                <br />

                <div className="card-header lh-mb-small ml-2">Active Contracts</div>
                <div className="agreements-card">
                    <div>
                        <Filter
                            sortItems={[
                                { group: 1, text: 'Contract Type', icon: 'alpha-up', orderName: 'leaseType', orderDirection: 'ascending' },
                                { group: 1, text: 'Contract Number', icon: 'alpha-up', orderName: 'leaseNumber', orderDirection: 'ascending' },
                                { group: 1, text: 'Owner Name', icon: 'alpha-up', orderName: 'ownerName', orderDirection: 'ascending' },
                                { group: 1, text: 'Leased By', icon: 'numeric-up', orderName: 'leasedBy', orderDirection: 'ascending' },
                            ]}
                            filterItems={[
                                { group: 1, text: 'Contract Type', orderName: 'leaseType', orderDirection: 'descending' },
                                { group: 1, text: 'Contract Number', orderName: 'leaseNumber', orderDirection: 'descending' },
                                { group: 1, text: 'Owner Name', orderName: 'ownerName', orderDirection: 'descending' },
                                { group: 1, text: 'Leased By', orderName: 'leasedBy', orderDirection: 'descending' },
                            ]}
                            actions={[{ text: 'Generate Contract', action: () => this.props.showDialog(DialogList.LEASING_OWNER_SEARCH) }]}
                            onFilterChanged={this.handleFilterChanged}
                        />
                        <div style={{ overflow: 'auto', maxHeight: '65vh' }} id="what">
                            {!!this.contracts && (
                                <AgreementsList
                                    generatedAgreements={this.contracts}
                                    pageType="ContractGeneration"
                                    navigate={this.props.navigate}
                                    clientNumber={this.clientNumber}
                                    projectNumber={this.projectNumber}
                                    incrementPage={this.onIncrementPage}
                                    showVoidAgreement={this.onShowVoidAgreement}
                                />
                            )}
                            {!this.contracts && <LoadingSpinner />}
                        </div>
                    </div>
                </div>

                <LeasingOwnerSearch
                    onSearchOwners={this.searchUpdate}
                    onGetLeaseGenerationCollection={this.onGetLeaseGenerationCollection}
                    {...this.props}
                    onGetOwnerData={this.onGetOwnerData}
                    projectData={this.props.projectData}
                />

                <VoidAgreementDialog voidAgreement={this.onVoidAgreement} />
            </>
        );
    }
}

const mapDispatchToProps: ILeasingDispatchProps = {
    navigate: (path: string, search?: string) => push({ pathname: path, search }),
    searchOwners: (clientNumber: number, projectNumber: number, searchText: string, ownerType: string) =>
        actions.tract.getSearchOwners(clientNumber, projectNumber, searchText, ownerType),
    showDialog: (dialogName: string) => actions.layout.showDialog(dialogName),
    getLeaseGenerationCollection: (projectId: number, ownerLookUpId: number) =>
        actions.leaseGeneration.getLeaseGenerationFormCollection({ projectId, ownerLookUpId }),
    getProjectData: (clientNumber: number, projectNumber: number) => actions.project.getProject(clientNumber, projectNumber),
    // getAgreementsByUserId: (projectNumber: number) => actions.leaseGeneration.getAgreementsByUser({ projectNumber }),

    getGeneratedContracts: (clientNumber: number, projectNumber: number, options: ODataOptions) =>
        actions.leaseGeneration.getGeneratedContracts({ clientNumber, projectNumber, options }),
    incrementPage: (clientNumber: number, projectNumber: number) => actions.leaseGeneration.incrementAcqPage(clientNumber, projectNumber),
    resetPage: () => actions.leaseGeneration.resetAcqPage(),
    getOwnerData: (clientId: number, projectId: number, ownerId: number) => actions.leaseGeneration.getOwnerData({ clientId, projectId, ownerId }),
    setAgreementStatus: (clientNumber: number, projectNumber: number, ownerId: number, leaseFormId: number, leaseType: number, status: number, explanation: string) =>
        actions.leaseGeneration.setAgreementStatus({ clientNumber, projectNumber, ownerId, leaseFormId, leaseType, status, explanation }),
    hideDialog: () => actions.layout.hideDialog(),
};

function mapStateToProps(state: IRootState) {
    return {
        searchResults: selectors.tract.searchOwnersResults(state),
        leaseGenerationCollection: selectors.leaseGeneration.leaseGenerationFormCollection(state),
        agreements: selectors.leaseGeneration.agreements(state),
        surfaceAgreements: selectors.leaseGeneration.generatedContracts(state),
        ownerData: state.leaseGeneration.ownerData,
        projectData: state.project.currentProject,
        pathName: state.router.location.pathname,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Leasing);



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/Leasing.tsx